import { render, staticRenderFns } from "./ImmobilesMap.vue?vue&type=template&id=874a9d28&scoped=true"
import script from "./ImmobilesMap.vue?vue&type=script&lang=js"
export * from "./ImmobilesMap.vue?vue&type=script&lang=js"
import style0 from "./ImmobilesMap.vue?vue&type=style&index=0&id=874a9d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_xsnsr4smgwphgcec6u2nh24t5a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874a9d28",
  null
  
)

export default component.exports